import { render, staticRenderFns } from "./CmfPickupStep3.vue?vue&type=template&id=6dee9fb4&scoped=true"
import script from "./CmfPickupStep3.vue?vue&type=script&lang=js"
export * from "./CmfPickupStep3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dee9fb4",
  null
  
)

export default component.exports